<template lang="html">
  <div class="payment-settings">
    <div class="section-header">
      <h2>Payment</h2>
    </div>

    <section v-if="hasPurchased">
      <h3 class="success" v-if="hasSuccess">Payment successful!</h3>

      <h4>You have full access to this draft. Enjoy!</h4>
    </section>

    <section v-else>
      <p>
        The first three rounds of the draft are on us.
        Feel free to jump into the draft and see what you think.
        If you want to complete the draft just pay $15 once and you're good to go.
      </p>

      <br />

      <draft-payment @success="showSuccess" />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DraftPayment from '@/components/DraftPayment';

export default {
  components: {
    DraftPayment,
  },

  data() {
    return {
      hasSuccess: false,
    };
  },

  computed: {
    ...mapState({
      hasPurchased: ({ draft }) => draft.draft.purchased,
    }),
  },

  methods: {
    showSuccess() {
      this.hasSuccess = true;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "./settings";

  .payment-settings {
    @include settingSection;
  }
</style>
